import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetAllHiredCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetHiredCandidates", {
    token,
  });
};
